import { render, staticRenderFns } from "./SampleTypeDetailCardstack.vue?vue&type=template&id=4d9e0f3d"
import script from "./SampleTypeDetailCardstack.vue?vue&type=script&lang=js"
export * from "./SampleTypeDetailCardstack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports